var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrownClicked = function SvgCrownClicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F54EB",
    d: "m21.71 6.48-4.561 2.81-4.374-5.833a.188.188 0 0 0-.302 0L8.102 9.291 3.538 6.48a.19.19 0 0 0-.286.185l1.791 13.607a.38.38 0 0 0 .375.329h14.417c.187 0 .349-.141.372-.329l1.79-13.607a.19.19 0 0 0-.288-.185m-9.085 10.728a2.64 2.64 0 0 1-2.639-2.64 2.64 2.64 0 0 1 2.64-2.638 2.64 2.64 0 0 1 2.638 2.639 2.64 2.64 0 0 1-2.639 2.639m0-3.771a1.132 1.132 0 0 0 0 2.264 1.13 1.13 0 0 0 0-2.264"
  })));
};
export default SvgCrownClicked;